<template>
 <div>
    <CRUDCriteria
      :showReset="true"
      :showSearch="false"
      :showAdditionalActions="true"
    >
      <template v-slot:criteriaRows>
        <v-row>
          <v-col cols="3">
            <FySelect id="sai-monthly-criteria-FY"
              v-model="saiMonthlySummaryCriteriaState.fiscalYear"
              label="FY"
              :fyRange="fiscalYearRange"
              @input="onChangeFy"
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete id="sai-monthly-criteria-month"
              v-model="saiMonthlySummaryCriteriaState.monthyear"
              label="By Year - Month"
              :items="monthYearRange"
              item-text="name"
              item-value="monthyear"
              @change="onChangeMonthYear"
            >
            </v-autocomplete>
          </v-col>
            <UploadFile  id="saiTransUploadFile"
          class="glSaitrans uploadFile mt-9"
          :bucketName="attachmentConstants.bucketName"
          :program="attachmentConstants.program"
          :parentObjectType="attachmentConstants.parentObjectType"
          :parentObjectId="monthYearString"
          :itemIsSaved="ismonthYearSaved"
          :audit= "false"
        >
        <template v-slot:activator="{ activatorProps }">
        <v-btn
          color="primary"
          class="mr-9 pl-9"
          :disabled="!isDisabledUploadFileBtn"
          text
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
        {{activatorProps.caption}}
        </v-btn>
        </template>
       </UploadFile>
        </v-row>
      </template>
      <template v-slot:additionalActions>
        <v-col cols="5">
          <v-btn
            rounded
            dense
            class= "tmc-additional-actions-collect-information"
            color="primary"
            :disabled="isSummaryBtnDisabled"
            @click="collectInfo"
          >
          <v-icon class="mr-2">{{ icons.mdiDatabaseSyncOutline }}</v-icon>
            {{dynamicLabel}}
          </v-btn>
        </v-col>
      </template>
    </CRUDCriteria>
  </div>
</template>
<script>
import { mdiDatabaseSyncOutline } from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import FySelect from '../../common/FySelect.vue';
import UploadFile from '../../common/UploadFile.vue';
import {
  calculateFiscalYears, getIdFromList, getMonthYearRange,
} from '../../../util/shared/tmc-global';
import { checkStringEmptiness } from '../../../util/shared/vue-global';

export default {
  name: 'SaiMonthlyCriteria',
  components: {
    CRUDCriteria,
    FySelect,
    UploadFile,
  },
  props: {
    saiMonthlySummaryBaseCrudKey: {
      type: String,
      default: '',
    },
    saiMonthlyTransactionBaseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    icons: {
      mdiDatabaseSyncOutline,
    },
    uploadFileParams: {
      bucketName: 'sai',
      program: 'sai',
      parentObjectType: null,
    },
    attachmentConstants: {
      bucketName: 'sai',
      program: 'sai',
      parentObjectType: 'saiTransaction',
    },
    uploadFileClickParams: {
      leftClickFlag: false,
      leftClickDef: undefined,
      rightClickFlag: false,
      rightClickDef: undefined,
    },
    monthYearString: '',
    ismonthYearSaved: false,
    isDisabledUploadFileBtn: false,
  }),
  created() {
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      SaiMonthlyTransactionSectionTypes: (state) => state.enums.SaiMonthlyTransactionSectionEnum,
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears, false);
      },
      emptyStore: (state) => state.glDaily.saiMonthlySummaryTransaction.emptyStore,
    }),
    saiMonthlyTransactionCriteriaState: {
      get() {
        return this.criteria(this.saiMonthlyTransactionBaseCrudKey);
      },
      set(value) {
        this.setCriteria([this.saiMonthlyTransactionBaseCrudKey, value]);
      },
    },
    saiMonthlySummaryCriteriaState: {
      get() {
        return this.criteria(this.saiMonthlySummaryBaseCrudKey);
      },
      set(value) {
        this.setCriteria([this.saiMonthlySummaryBaseCrudKey, value]);
      },
    },
    saiSections() {
      if (!this.SaiMonthlyTransactionSectionTypes) {
        return [];
      }
      return this.SaiMonthlyTransactionSectionTypes;
    },
    monthYearRange() {
      const inputYear = this.saiMonthlySummaryCriteriaState.fiscalYear;
      const range = getMonthYearRange(inputYear);
      return range.reverse();
    },
    isSummaryBtnDisabled() {
      const items = this.items(this.saiMonthlySummaryBaseCrudKey) || [];
      if (items.length > 0 && items[0].isLocked) {
        this.setSumaryLockUnlock(false);
        return true;
      }
      this.setSumaryLockUnlock(true);
      return false;
    },

    /*
    incomplete disabling button logic for sai create record
    isDisableBtn() {
      console.info(this.saiMonthlySummaryCriteriaState, 'cri');
      console.info((this.saiMonthlySummaryCriteriaState.monthyear != null));
      // const items = this.items(this.saiMonthlySummaryBaseCrudKey) || [];
      const currentMonth = destructureDate(this.todaysDate).month;
      const currentYear = destructureDate(this.todaysDate).year;
      console.info(currentYear, 'todays year');
      console.info(currentMonth, 'todays month');
      const selectedMonthYear = this.saiMonthlySummaryCriteriaState.monthyear;
      console.info(selectedMonthYear.yrea, 'todays year');
      if ((selectedMonthYear != null) && (currentMonth >= selectedMonthYear.month)
      && (currentYear >= selectedMonthYear.year)) {
        return false;
      }
      return true;
    },
    */
    dynamicLabel() {
      const items = this.items(this.saiMonthlySummaryBaseCrudKey) || [];
      return (items.length || []) > 0 ? 'Update New Summary Record' : 'Create New Summary Record';
    },
  },
  methods: {
    checkStringEmptiness,
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItems',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions({
      loadDepartments: 'OD/loadDepartments',
    }),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapMutations('glDaily/saiMonthlySummaryTransaction', [
      'setSumaryLockUnlock',
    ]),
    ...mapActions('glDaily/saiMonthlySummaryTransaction', [
      'saiMonthlyCollectInformation',
      'loadSaiMonthlySummary',
    ]),
    ...mapActions('glDaily/saiMonthlyTransaction', [
      'loadSaiMonthlyTransaction',
    ]),
    emitSummaryList() {
      this.$emit('loadSaiMonthlySummaryList');
    },
    onChangeFy() {
      this.saiMonthlySummaryCriteriaState.monthyear = {};
      this.setItems([this.saiMonthlySummaryBaseCrudKey, []]);
      this.setItems([this.saiMonthlyTransactionBaseCrudKey, []]);
      this.loadLists();
    },
    onChangeMonthYear() {
      this.ismonthYearString();
      this.disabledUploadFileBtn();
      this.ismonthyear();
      this.emitSummaryList();
      this.loadFiles();
    },
    ismonthYearString() {
      const ismonthYear = this.saiMonthlySummaryCriteriaState.monthyear || '';
      this.monthYearString = `month: ${ismonthYear.month}, year: ${ismonthYear.year}`;
      return this.monthYearString;
    },
    disabledUploadFileBtn() {
      this.isDisabledUploadFileBtn = this.saiMonthlySummaryCriteriaState.monthyear != null;
      if (this.isDisabledUploadFileBtn) {
        this.isDisabledUploadFileBtn = this.saiMonthlySummaryCriteriaState.monthyear.month !== null
          && this.saiMonthlySummaryCriteriaState.monthyear.year !== null;
      }

      return this.isDisabledUploadFileBtn;
    },
    ismonthyear() {
      this.ismonthYearSaved = this.saiMonthlySummaryCriteriaState.monthyear != null;
      if (this.ismonthYearSaved !== null) {
        return this.ismonthYearSaved.month !== null
          && this.ismonthYearSaved.year !== null;
      }
      return false;
    },
    async loadLists() {
      await this.loadFundList();
      await this.loadDepartmentList();
    },
    async loadFundList() {
      await this.loadFunds({
        criteria: {
          fiscalYear: this.saiMonthlySummaryCriteriaState.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedFund',
      });
    },
    async loadDepartmentList() {
      await this.loadDepartments(this.saiMonthlySummaryCriteriaState);
    },
    loadTransactionList() {
      const criteria = this.saiMonthlyTransactionCriteriaState;
      const itemId = getIdFromList(this, this.saiMonthlySummaryBaseCrudKey);
      // permanently updating summary ID to criteria
      criteria.saiMonthlySummary = itemId;
      this.loadSaiMonthlyTransaction({
        criteria,
        baseCrudKey: this.saiMonthlyTransactionBaseCrudKey,
      });
    },
    async collectInfo() {
      const { month, year } = this.saiMonthlySummaryCriteriaState.monthyear;
      const criteria = {
        year,
        month,
        fiscalYear: this.saiMonthlySummaryCriteriaState.fiscalYear,
      };
      await this.saiMonthlyCollectInformation({ criteria });
      // emiting to saibase list to load summary and transaction list
      this.emitSummaryList();
    },
    async imagesLeftClick(leftClick) {
      if (this.isNew) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNew) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
      } else {
        rightClick();
      }
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.monthYearString,
      });
    },
  },
};
</script>
